import { type FC, type HTMLAttributes, useId } from 'react'

const SplashGraphic: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const gradientId = useId()
  const filterId = useId()
  const clipId = useId()

  return (
    <div {...props}>
      <svg
        viewBox="0 0 280 283"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="block mx-auto w-full"
        role="img"
        aria-hidden="true"
      >
        <g clipPath={`url(#${clipId}-0)`}>
          <rect
            x="182.141"
            y="64"
            width="101"
            height="101"
            rx="16"
            transform="rotate(15 182.141 64)"
            fill="#121212"
          />
          <g clipPath={`url(#${clipId}-1)`}>
            <rect
              x="127.265"
              y="40.8413"
              width="165"
              height="117.333"
              rx="13.75"
              transform="rotate(15 127.265 40.8413)"
              fill="#0D0A2C"
            />
            <g filter={`url(#${filterId}-0)`}>
              <path
                d="M271.285 112.667C279.991 117.498 292.039 102.777 299.886 103.406C327.761 105.64 303.319 179.346 273.231 182.296C244.765 185.087 233.104 122.059 233.104 122.059C233.104 122.059 234.355 105.137 241.107 100.528C247.201 96.3674 250.758 98.987 256.892 102.666C261.739 105.573 266.349 109.927 271.285 112.667Z"
                fill="#00A3FF"
              />
            </g>
            <g filter={`url(#${filterId}-1)`}>
              <path
                d="M244.426 134.863C258.143 142.219 284.972 131.177 297.246 132.296C340.847 136.269 304.05 202.718 257.115 206.36C212.712 209.806 185.004 147.839 185.004 147.839C185.004 147.839 182.773 123.868 193.211 117.212C202.631 111.205 212.031 114.137 221.702 119.726C229.342 124.141 236.649 130.693 244.426 134.863Z"
                fill="#9CF473"
              />
            </g>
            <g filter={`url(#${filterId}-2)`}>
              <ellipse
                cx="195.363"
                cy="187.797"
                rx="57.9792"
                ry="49.5"
                transform="rotate(15 195.363 187.797)"
                fill="#E1D569"
              />
            </g>
            <g filter={`url(#${filterId}-3)`}>
              <path
                d="M113.683 144.515C103.709 159.587 93.8691 170.725 97.6666 188.393C105.07 222.84 160.714 237.493 184.742 211.725C203.733 191.358 187.528 167.638 180.356 140.731C177.192 128.858 180.839 119.566 172.002 111.038C152.228 91.9552 128.858 121.581 113.683 144.515Z"
                fill="#E64848"
              />
            </g>
          </g>
          <path
            d="M185.989 131.807L192.346 108.083L193.854 104.926L199.148 106.345L191.901 133.391L185.989 131.807ZM185.188 112.543L186.699 106.902C187.381 107.14 188.131 107.175 188.949 107.008C189.792 106.847 190.641 106.564 191.495 106.158C192.382 105.733 193.175 105.297 193.875 104.849L196.791 109.73C195.548 110.557 194.265 111.276 192.942 111.887C191.625 112.473 190.322 112.856 189.032 113.034C187.748 113.187 186.467 113.024 185.188 112.543ZM200.314 136.266C199.336 136.004 198.592 135.432 198.082 134.55C197.573 133.668 197.45 132.738 197.712 131.759C197.968 130.806 198.536 130.075 199.418 129.566C200.3 129.057 201.23 128.933 202.209 129.196C203.162 129.451 203.893 130.02 204.402 130.901C204.911 131.783 205.038 132.701 204.783 133.654C204.521 134.632 203.948 135.376 203.067 135.886C202.185 136.395 201.267 136.522 200.314 136.266ZM216.867 140.577C215.527 140.218 214.237 139.624 212.996 138.795C211.755 137.965 210.711 136.968 209.864 135.802C209.043 134.643 208.585 133.361 208.493 131.956L214.738 132.139C214.945 132.912 215.326 133.552 215.88 134.06C216.467 134.548 217.134 134.893 217.881 135.093C219.014 135.396 220.018 135.307 220.893 134.823C221.801 134.321 222.41 133.49 222.72 132.331C223.003 131.275 222.894 130.293 222.391 129.386C221.922 128.459 221.095 127.837 219.91 127.52C219.189 127.327 218.5 127.321 217.843 127.504C217.213 127.694 216.707 127.987 216.325 128.381L211.054 125.644L216.858 111.09L232.545 115.293L231.033 120.934L220.601 118.139L218.348 123.457C219.121 123.25 219.961 123.158 220.866 123.179C221.778 123.175 222.736 123.308 223.741 123.577C225.125 123.975 226.303 124.678 227.276 125.684C228.275 126.697 228.959 127.902 229.33 129.299C229.708 130.67 229.687 132.141 229.266 133.712C228.762 135.593 227.892 137.14 226.655 138.355C225.426 139.544 223.97 140.341 222.288 140.746C220.606 141.151 218.799 141.095 216.867 140.577ZM228.543 143.209L239.453 134.33L247.165 127.493L254.274 129.398L243.501 138.231L235.729 145.134L228.543 143.209ZM242.413 146.925L239.212 137.081L234.221 124.025L241.331 125.93L244.63 135.717L249.561 148.841L242.413 146.925Z"
            fill="white"
          />
        </g>
        <rect
          x="183.025"
          y="65.5309"
          width="98.5"
          height="98.5"
          rx="14.75"
          transform="rotate(15 183.025 65.5309)"
          stroke={`url(#${gradientId})`}
          strokeWidth="2.5"
        />
        <g filter={`url(#${filterId}-4)`}>
          <g clipPath={`url(#${clipId}-2)`}>
            <rect
              x="143.383"
              y="145"
              width="100"
              height="107.447"
              rx="17.0213"
              transform="rotate(22.6527 143.383 145)"
              fill="#BD3E40"
              fillOpacity="0.75"
            />
            <g clipPath={`url(#${clipId}-3)`}>
              <path
                d="M184.211 200.651L175.171 196.982L184.62 195.997L185.511 188.738L189.003 194.748L195.783 192.961L192.225 197.69L200.292 202.198L190.041 201.954L183.966 206.624L184.211 200.651Z"
                fill="#FFE36C"
              />
              <path
                d="M193.084 194.774L192.104 196.072L190.638 198.025L192.77 199.214L196.015 201.024L190.443 200.894L189.691 200.874L189.095 201.335L185.124 204.387L185.247 201.441L185.309 199.939L183.916 199.381L179.524 197.6L183.887 197.144L185.575 196.967L185.782 195.283L186.183 192.016L187.672 194.579L188.488 195.98L190.055 195.568L193.084 194.774ZM189.514 193.509L185.263 186.196C185.125 185.96 184.766 186.035 184.734 186.304L183.664 195.028L171.95 196.248C171.654 196.281 171.595 196.683 171.872 196.793L183.117 201.353L182.832 208.249C182.823 208.492 183.099 208.631 183.292 208.487L190.396 203.025L203.421 203.331C203.717 203.339 203.826 202.941 203.568 202.798L193.811 197.355L197.983 191.805C198.147 191.591 197.946 191.287 197.686 191.358L189.514 193.509Z"
                fill="#FF8F00"
              />
              <path
                d="M187.888 210.428C187.302 210.079 182.902 211.88 181.47 209L181.463 209.003C180.593 207.386 179.535 205.879 178.311 204.511C169.759 194.965 155.083 194.154 145.529 202.709C135.983 211.262 135.172 225.938 143.727 235.491C152.28 245.037 166.956 245.848 176.509 237.293C179.61 234.518 181.786 231.098 183.018 227.416C183.103 227.157 183.29 226.584 183.585 226.223C185.6 223.755 189.239 223.626 189.231 223.467C189.224 223.302 188.48 210.778 187.888 210.428Z"
                fill="#2F2929"
              />
              <path
                d="M189.381 223.449C191.08 223.232 192.086 220.144 191.627 216.55C191.169 212.957 189.42 210.22 187.721 210.437C186.022 210.654 185.017 213.742 185.475 217.335C185.933 220.928 187.682 223.665 189.381 223.449Z"
                fill="#757575"
              />
              <path
                d="M189.722 219.18C190.389 219.094 190.823 218.193 190.691 217.167C190.558 216.142 189.91 215.38 189.243 215.466C188.576 215.552 188.142 216.453 188.274 217.479C188.407 218.504 189.055 219.266 189.722 219.18Z"
                fill="#212121"
              />
              <path
                opacity="0.9"
                d="M166.218 206.156C165.969 210.537 163.05 211.993 159.894 212.388C158.386 212.577 156.845 212.291 155.332 212.449C152.392 212.755 149.888 214.667 147.07 215.549C146.367 215.768 145.605 215.923 144.897 215.714C143.953 215.435 143.291 214.536 143.056 213.58C142.828 212.62 143.547 204.724 154.539 200.925C159.449 199.228 166.493 201.355 166.218 206.156Z"
                fill="#757575"
              />
              <path
                d="M163.145 196.891C164.932 197.706 168.623 199.275 172.538 203.07C173.855 204.346 174.825 205.766 175.885 207.245C176.741 208.438 177.804 209.579 179.207 210.015C179.702 210.17 180.305 210.202 180.676 209.838C180.904 209.611 181.01 209.327 181.027 209.011C181.044 208.638 180.83 208.018 180.423 207.254C179.788 206.291 179.084 205.374 178.316 204.513C174.243 199.966 168.781 197.404 163.145 196.891Z"
                fill={`url(#${gradientId}-1)`}
              />
              <path
                d="M190.903 213.617C190.889 213.582 190.877 213.542 190.862 213.508C190.859 213.501 190.862 213.496 190.857 213.494C190.791 213.334 190.723 213.179 190.655 213.023C190.647 213.003 190.633 212.98 190.627 212.954C189.854 211.311 188.781 210.305 187.724 210.434C186.027 210.648 185.02 213.738 185.48 217.331C185.574 218.065 185.728 218.791 185.941 219.5C185.951 219.337 186.416 213.058 188.176 212.058C189.673 211.219 190.793 213.398 190.903 213.617Z"
                fill={`url(#${gradientId}-2)`}
              />
              <path
                d="M178.537 223.955C177.675 222.679 176.954 221.133 177.345 218.166C177.393 217.788 177.781 215.974 178.802 216.083C179.686 216.175 179.731 217.71 179.935 219.126C180.153 220.675 180.897 222.248 181.886 223.485C182.175 223.842 183.582 225.346 181.988 225.96C180.94 226.358 179.041 224.707 178.537 223.955Z"
                fill="#212121"
              />
              <path
                d="M189.087 216.202C189.144 216.203 195.071 216.019 196.009 212.555C196.63 210.266 196.236 208.834 192.212 205.909C188.275 203.05 186.986 200.132 186.935 200.007C186.674 199.402 186.952 198.694 187.564 198.43C188.168 198.17 188.871 198.446 189.137 199.053C189.159 199.096 190.275 201.533 193.627 203.97C197.528 206.802 199.429 209.112 198.331 213.178C197.102 217.726 191.23 218.428 189.573 218.572C188.542 218.666 188.425 216.214 189.087 216.202Z"
                fill="#C69461"
              />
              <path
                d="M189.125 199.053C188.864 198.449 188.156 198.171 187.552 198.431C186.945 198.697 186.664 199.398 186.923 200.007C186.96 200.098 187.665 201.683 189.582 203.648L190.389 203.027L192.478 203.075C190.007 200.972 189.144 199.09 189.125 199.053Z"
                fill="#F6BC41"
              />
            </g>
          </g>
        </g>
        <rect
          x="21"
          y="64.8594"
          width="151.5"
          height="151.5"
          rx="24"
          transform="rotate(-12.5268 21 64.8594)"
          fill="#222248"
        />
        <g filter={`url(#${filterId}-5)`}>
          <path
            d="M153.601 112.995C148.42 89.6749 125.315 74.9707 101.995 80.152C78.6753 85.3333 63.9712 108.438 69.1525 131.758C74.3338 155.078 97.4385 169.782 120.758 164.6C144.078 159.419 158.782 136.314 153.601 112.995Z"
            fill="#121212"
            stroke={`url(#${gradientId}-3)`}
            strokeWidth="4.00781"
          />
          <path
            d="M102.907 126.082L107.728 127.576L110.806 141.43L97.2468 137.174L93.1275 118.634L88.5095 117.094L93.67 140.32L116.42 147.452L111.305 124.43L101.865 121.396L102.907 126.082Z"
            fill="white"
          />
          <path
            d="M113.953 123.841L116.081 133.417L119.613 130.066L118.526 125.177L129.007 115.579L132.086 129.433L118.073 142.381L119.114 147.067L136.704 130.973L131.543 107.747L113.953 123.841Z"
            fill="white"
          />
          <path
            d="M114.678 113.632L110.943 117.027L97.3837 112.771L107.865 103.173L126.043 108.969L129.574 105.619L106.824 98.487L89.2342 114.582L111.984 121.713L119.251 114.967L114.678 113.632Z"
            fill="white"
          />
        </g>
        <rect
          x="100.073"
          y="19.6321"
          width="88"
          height="63"
          rx="31.5"
          transform="rotate(-12.5268 100.073 19.6321)"
          fill="#B70CEB"
        />
        <path
          d="M134.95 56.9558L134.157 53.3866L140.781 43.8118C141.338 42.9678 141.796 42.2179 142.154 41.5621C142.52 40.9045 142.771 40.2846 142.905 39.7025C143.038 39.1127 143.036 38.509 142.899 37.8912C142.747 37.2048 142.459 36.6485 142.036 36.2223C141.612 35.7884 141.099 35.4981 140.498 35.3515C139.896 35.1973 139.251 35.1964 138.565 35.3489C137.848 35.5082 137.255 35.792 136.785 36.2005C136.316 36.6089 135.996 37.116 135.827 37.7219C135.657 38.3278 135.656 39.0044 135.822 39.7518L131.12 40.7965C130.779 39.2635 130.831 37.8556 131.274 36.5727C131.717 35.2898 132.495 34.2005 133.609 33.3048C134.722 32.4092 136.095 31.7801 137.727 31.4174C139.405 31.0446 140.932 31.0176 142.307 31.3362C143.688 31.6456 144.842 32.2456 145.768 33.1362C146.694 34.0268 147.307 35.1471 147.607 36.497C147.804 37.3817 147.822 38.2939 147.663 39.2336C147.511 40.1717 147.11 41.2652 146.459 42.5142C145.807 43.7556 144.838 45.2873 143.555 47.1091L140.879 51.2209L140.914 51.3811L150.753 49.1952L151.652 53.2449L134.95 56.9558ZM158.58 46.3997L157.292 40.5514L158.002 40.3939L162.148 32.4739L167.742 31.231L162.143 41.7426L160.987 41.9993L158.58 46.3997ZM155.287 52.4372L150.082 29.0085L154.955 27.9258L160.161 51.3544L155.287 52.4372ZM166.27 49.9971L159.398 43.4928L161.882 39.3276L171.978 48.7288L166.27 49.9971Z"
          fill="white"
        />
        <g clipPath={`url(#${clipId}-4)`}>
          <rect
            y="182.5"
            width="101"
            height="101"
            rx="16"
            transform="rotate(-30 0 182.5)"
            fill="#121212"
          />
          <g clipPath={`url(#${clipId}-5)`}>
            <rect
              x="-12.1243"
              y="189.5"
              width="144.844"
              height="103"
              rx="12.0703"
              transform="rotate(-30 -12.1243 189.5)"
              fill="#0D0A2C"
            />
            <g filter={`url(#${filterId}-6)`}>
              <circle
                cx="108.544"
                cy="190.891"
                r="56.409"
                transform="rotate(-30 108.544 190.891)"
                fill="#FF16F0"
              />
            </g>
            <g filter={`url(#${filterId}-7)`}>
              <ellipse
                cx="71.8923"
                cy="158.996"
                rx="36.8145"
                ry="37.9209"
                transform="rotate(-30 71.8923 158.996)"
                fill="#1AC7FF"
              />
            </g>
            <g filter={`url(#${filterId}-8)`}>
              <circle
                cx="145.406"
                cy="190.165"
                r="27.46"
                transform="rotate(-30 145.406 190.165)"
                fill="#FF3333"
              />
            </g>
            <g filter={`url(#${filterId}-9)`}>
              <path
                d="M56.0635 231.26C67.8545 251.683 16.122 296.772 33.4168 286.787C42.5489 281.514 70.1603 271.868 82.7646 258.296C94.031 246.164 91.2437 230.334 85.6787 220.695C73.8878 200.272 41.2864 194.291 23.9915 204.276C6.6967 214.261 44.2726 210.838 56.0635 231.26Z"
                fill="#0032EF"
              />
            </g>
          </g>
          <path
            d="M66.6461 219.054C65.1219 219.934 63.5914 220.51 62.0545 220.782C60.5408 221.04 59.1149 220.97 57.7769 220.572C56.4486 220.138 55.2841 219.348 54.2834 218.201L58.8088 213.88C59.1074 214.077 59.4739 214.312 59.9084 214.584C60.366 214.844 60.9009 214.997 61.513 215.044C62.1118 215.067 62.7807 214.866 63.5197 214.439C64.4896 213.879 65.1051 213.185 65.366 212.357C65.6136 211.506 65.4907 210.653 64.9974 209.799C64.7041 209.291 64.3037 208.891 63.7963 208.598C63.2987 208.27 62.6533 208.165 61.86 208.285C61.0764 208.367 60.1073 208.742 58.9526 209.409L57.1513 210.449L55.0713 206.846L56.6648 205.926C58.0273 205.14 59.409 204.573 60.8099 204.226C62.2206 203.842 63.586 203.701 64.9062 203.801C66.2264 203.901 67.4054 204.236 68.4432 204.807C69.5041 205.365 70.3546 206.198 70.9946 207.306C71.8479 208.784 72.182 210.269 71.9968 211.762C71.8116 213.255 71.2372 214.633 70.2737 215.898C69.3102 217.162 68.101 218.214 66.6461 219.054ZM56.4913 209.306L54.5513 205.946L56.3526 204.906C57.8075 204.066 58.6952 203.23 59.0157 202.398C59.3361 201.566 59.2563 200.735 58.7763 199.904C58.4963 199.419 58.1342 199.058 57.6899 198.822C57.2457 198.586 56.7557 198.484 56.22 198.516C55.671 198.525 55.1309 198.683 54.5997 198.989C54.2071 199.216 53.843 199.519 53.5073 199.897C53.1716 200.276 52.9305 200.738 52.7841 201.285C52.6377 201.831 52.6588 202.481 52.8474 203.234L46.9312 204.987C46.4252 203.524 46.3462 202.107 46.694 200.736C47.0516 199.329 47.7041 198.059 48.6517 196.927C49.5859 195.772 50.6881 194.828 51.9583 194.094C53.4825 193.214 55.0232 192.71 56.5805 192.58C58.1476 192.415 59.5824 192.633 60.885 193.236C62.1974 193.802 63.2402 194.755 64.0135 196.095C64.6802 197.249 64.9649 198.409 64.8675 199.574C64.7933 200.725 64.4427 201.851 63.8158 202.952C63.1988 204.017 62.3929 205.021 61.3982 205.965C60.3901 206.885 59.2857 207.692 58.0848 208.386L56.4913 209.306ZM76.2631 212.948L77.6991 198.955L78.3182 188.667L84.6921 184.987L83.32 198.851L82.7063 209.228L76.2631 212.948ZM88.6992 205.768L79.4748 201.071L66.7134 195.367L73.0874 191.687L82.341 196.275L95.1078 202.068L88.6992 205.768Z"
            fill="white"
          />
        </g>
        <rect
          x="1.70753"
          y="182.958"
          width="98.5"
          height="98.5"
          rx="14.75"
          transform="rotate(-30 1.70753 182.958)"
          stroke={`url(#${gradientId}-4)`}
          strokeWidth="2.5"
        />
        <defs>
          <filter
            id={`${filterId}-0`}
            x="184.979"
            y="50.2786"
            width="175.263"
            height="180.233"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="24.0625"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-1`}
            x="127.513"
            y="56.5984"
            width="246.491"
            height="207.192"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="28.6458"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-2`}
            x="89.7748"
            y="89.5457"
            width="211.176"
            height="196.503"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="24.0625"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-3`}
            x="48.7076"
            y="56.7989"
            width="193.064"
            height="216.137"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="24.0625"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-4`}
            x="100.12"
            y="143.12"
            width="137.428"
            height="143.552"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.94" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_11_140"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_11_140"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.84388 0 0 0 0 0.608434 0 0 0 0 0.608434 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect2_innerShadow_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-5`}
            x="34.9093"
            y="51.9087"
            width="152.935"
            height="152.935"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="6" />
            <feGaussianBlur stdDeviation="15.6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.966667 0 0 0 0 0 0 0 0 0 1 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11_140"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11_140"
              result="shape"
            />
          </filter>
          <filter
            id={`${filterId}-6`}
            x="9.87915"
            y="92.2267"
            width="197.329"
            height="197.329"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="21.123"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-7`}
            x="-27.5709"
            y="58.9784"
            width="198.926"
            height="200.035"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="31.1816"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-8`}
            x="75.6952"
            y="120.454"
            width="139.421"
            height="139.421"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="21.123"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <filter
            id={`${filterId}-9`}
            x="-22.7312"
            y="157.299"
            width="155.511"
            height="173.158"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="21.123"
              result="effect1_foregroundBlur_11_140"
            />
          </filter>
          <linearGradient
            id={gradientId}
            x1="232.641"
            y1="64"
            x2="232.641"
            y2="165"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.5" />
            <stop offset="1" stopColor="white" stopOpacity="0.25" />
          </linearGradient>
          <linearGradient
            id={`${gradientId}-1`}
            x1="164.107"
            y1="194.89"
            x2="181.825"
            y2="210.072"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFF9C4" stopOpacity="0.1" />
            <stop offset="0.002" stopColor="#FFF9C4" stopOpacity="0.101" />
            <stop offset="0.378" stopColor="#FFFCA6" stopOpacity="0.263" />
            <stop offset="0.701" stopColor="#FFFE94" stopOpacity="0.401" />
            <stop offset="0.93" stopColor="#FFFF8D" stopOpacity="0.5" />
          </linearGradient>
          <linearGradient
            id={`${gradientId}-2`}
            x1="188.874"
            y1="218.339"
            x2="186.472"
            y2="209.056"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.11" stopColor="#FFF9C4" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFF8D" />
          </linearGradient>
          <linearGradient
            id={`${gradientId}-3`}
            x1="62.1617"
            y1="91.0552"
            x2="160.592"
            y2="153.697"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#828282" />
            <stop offset="1" stopColor="#373737" />
          </linearGradient>
          <linearGradient
            id={`${gradientId}-4`}
            x1="50.5"
            y1="182.5"
            x2="50.5"
            y2="283.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.5" />
            <stop offset="1" stopColor="white" stopOpacity="0.25" />
          </linearGradient>
          <clipPath id={`${clipId}-0`}>
            <rect
              x="182.141"
              y="64"
              width="101"
              height="101"
              rx="16"
              transform="rotate(15 182.141 64)"
              fill="white"
            />
          </clipPath>
          <clipPath id={`${clipId}-1`}>
            <rect
              x="127.265"
              y="40.8413"
              width="165"
              height="117.333"
              rx="13.75"
              transform="rotate(15 127.265 40.8413)"
              fill="white"
            />
          </clipPath>
          <clipPath id={`${clipId}-2`}>
            <rect
              x="143.383"
              y="145"
              width="100"
              height="107.447"
              rx="17.0213"
              transform="rotate(22.6527 143.383 145)"
              fill="white"
            />
          </clipPath>
          <clipPath id={`${clipId}-3`}>
            <rect
              width="68.0851"
              height="68.0851"
              fill="white"
              transform="translate(150.529 169.309) rotate(22.6527)"
            />
          </clipPath>
          <clipPath id={`${clipId}-4`}>
            <rect
              y="182.5"
              width="101"
              height="101"
              rx="16"
              transform="rotate(-30 0 182.5)"
              fill="white"
            />
          </clipPath>
          <clipPath id={`${clipId}-5`}>
            <rect
              x="-12.1243"
              y="189.5"
              width="144.844"
              height="103"
              rx="12.0703"
              transform="rotate(-30 -12.1243 189.5)"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default SplashGraphic
